// Configuration Settings

export var config = {
    maxQuestions: 5,
    maxAnswers: 5,

    serviceAcceptHeaderParm: 'application/vnd.awm.ampf.com+json',

    Env: 'QA',
   
     /**retrieveMarketingEventInviteeByRSVPIdentifierURL: 'https://rsvp.ameriprise.com/ods.svc/retrieveMarketingEventInviteeByRSVPIdentifier?RSVPId=',
    getRSVPConfigURL: 'https://rsvp.ameriprise.com/ods.svc/getMarketingEventRSVPQuestionnaire?evntId=',
    saveRSVPConfigURL: 'https://rsvp.ameriprise.com/ods.svc/createMarketingEventInviteeRSVPChoices',
    updateCampaignMember : 'https://rsvp.ameriprise.com/ods.svc/updateFieldCRMCampaignMember'*/

    retrieveMarketingEventInviteeByRSVPIdentifierURL: 'https://rsvp.qa.ameriprise.com/ods.svc/retrieveMarketingEventInviteeByRSVPIdentifier?RSVPId=',
    getRSVPConfigURL: 'https://rsvp.qa.ameriprise.com/ods.svc/getMarketingEventRSVPQuestionnaire?evntId=',
    saveRSVPConfigURL: 'https://rsvp.qa.ameriprise.com/ods.svc/createMarketingEventInviteeRSVPChoices',
	updateCampaignMember : 'https://rsvp.qa.ameriprise.com/ods.svc/updateFieldCRMCampaignMember'

}